import { updateWorkOrderTemplate } from '#/graphql/mutations';
import type { WorkOrderTemplate, UpdateWorkOrderTemplateMutation } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { GET_WORK_ORDER_TEMPLATE } from './useWOTemplateQuery';

const q = gql(updateWorkOrderTemplate);

const useWOTemplateUpdate = () => {
  const [mutation, result] = useMutation<UpdateWorkOrderTemplateMutation>(q);

  const updateWOTemplate = useCallback(
    async (woTemplateId: string, woTemplate: WorkOrderTemplate) => {
      const {
        __typename,
        id,
        tenantId,
        displayNumber,
        createdAt,
        createdBy,
        updatedAt,
        updatedBy,
        userId,
        locationId,
        model,
        tenant,
        manufacturer,
        assetType,
        createdByUser,
        updatedByUser,
        assignedTo,
        ...woTemplateInput
      } = woTemplate;

      const response = await mutation({
        variables: {
          id: woTemplateId,
          data: woTemplateInput,
        },
        refetchQueries: [{ query: GET_WORK_ORDER_TEMPLATE, variables: { id: woTemplateId } }],
        awaitRefetchQueries: true,
      });

      return response.data?.updateWorkOrderTemplate || undefined;
    },
    [mutation],
  );

  return { updateWOTemplate, result };
};

export default useWOTemplateUpdate;
